import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange, OnClick, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { URLHash } from "../../../library-js/dom/URLHash";
import { RegexValidator } from "../../../library-js/validators/RegexValidator";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { GeneralLocales } from "../i8/GeneralLocales";
import { OverlayHint } from "../overlay/OverlayHint";


export class UserAccountBlock
{
  static readonly type = new ElementType<HTMLElement>( "user-account-block" );
  static readonly info = new ElementType<HTMLElement>( "user-account-info" );
  static readonly inputBlock = new ElementType<HTMLElement>( "input-block" );

  static readonly emailInput = new AttributeValue( ElementAttribute.nameAttribute, "EMAIL" );
  static readonly nameInput  = new AttributeValue( ElementAttribute.nameAttribute, "NAME" );
  static readonly pwInput    = new AttributeValue( ElementAttribute.nameAttribute, "PASSWORD" );
  static readonly userButton = new ElementAttribute( "user-button" ); 

  static readonly invalidState = new ElementType( "invalid-state" );
  static readonly invalidInputs = new ElementType( "invalid-inputs-container" );
  static readonly validInputs = new ElementType( "valid-inputs-container" );
  static readonly inputValidation = new ElementType( "input-validation" );

  static readonly validationMessage = new ElementType( "validation-message" );

  static readonly inputField = new ElementType( "input-field" );

  static setInputFieldState( input:HTMLInputElement, isOK:boolean )
  {
    let inputField = UserAccountBlock.inputField.getParent( input );
    
    ClassFlag.error.setAs( inputField, ! isOK );
    ClassFlag.ok.setAs( inputField, isOK );    
  }

  static blurOnEnter( inputElement:HTMLInputElement )
  {
    OnKeyUp.add( inputElement, 
      ( k )=>
      { 
        if ( k.key === "Enter" )
        {
          inputElement.blur();
        }
      } 
    )
  }

  static hint( element:Element, elementType:ElementType<Element> )
  {
    let content = elementType.query( element ).cloneNode( true ) as HTMLElement;
    let title:HTMLElement|string = ElementType.h1.query( content );

    if ( title && typeof( title ) !== "string")
    {
      HTMLEditor.remove( title );
    }
    else
    {
      title = Rokojori.locale( GeneralLocales.hintUpperCase );
    }

    OverlayHint.hint( title, content );  
  }
  
  static setValidationMessage( e:Element, attribute:ClassFlag )
  {
    let inputValidation = UserAccountBlock.inputValidation.query( e );
    let messages = UserAccountBlock.validationMessage.queryAll( inputValidation );

    for ( let m of messages )
    {
      ClassFlag.hidden.setAs( m, ! attribute.in( m ) );
    }
  }

  static setReadonlyState( input:HTMLInputElement, readonly:boolean = true )
  {
    if ( readonly )
    { 
      ElementAttribute.readonly.to( input );
    }
    else
    {
      ElementAttribute.readonly.removeFrom( input );
    }
    
  }
}